module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ldibgK/media/FC-9781638298427.jpg?1697494195177",
      "alt": "This image is the cover for the book Alone Together"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alone Together\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Le Monde Journal Std\",serif"
    }
  }, [_vm._v("In the gripping novel, "), _c('em', [_vm._v("Alone Together,")]), _vm._v(" the world as we know it has been ravaged by an unforgiving virus, leaving Bree Wasson and her family to navigate a shattered landscape. As Bree reflects on her tumultuous journey from the age of fifteen to nineteen, a chilling reality unfolds—the global population has plummeted from over eight billion to a mere five.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Le Monde Journal Std\",serif"
    }
  }, [_vm._v("United by an unbreakable bond, Bree, her sister Jenn, and their partners Zack and Hawk embark on a perilous quest, their young brother Davy in tow, in search of other survivors. However, the relentless hardships they encounter along the way test the limits of their endurance and resilience. Strained relationships and personal losses threaten to erode the flicker of hope that keeps them going.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Le Monde Journal Std\",serif"
    }
  }, [_vm._v("Alone Together")])]), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Le Monde Journal Std\",serif"
    }
  }, [_vm._v(" explores the delicate balance between survival and the human spirit’s yearning for connection. As this small family confronts the daily struggles of existence, they grapple with the complexities of their relationships and the weight of their individual grief. Yet, they refuse to relinquish the belief that somewhere out there, others may still endure.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tawna Hutchison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Although born in Murray County Utah, when she was two her family moved to Baltimore Maryland where she spent her childhood until she was twelve years old. Her family then moved to Tucson Arizona. After returning briefly to Maryland they returned to Tucson when she graduated high school, where she currently lives with her husband William. In 2004, she obtained a BA in English from the University of Arizona and currently works as a substitute teacher.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0